export enum ConversionsApiStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  ERROR = 'error',
}
